import { Box, Fade, Tooltip } from '@mui/material';

import { LegacyNotificationList } from '~/legacy-components/LegacyNotificationList';

import { useLegacyNotificationsPaper } from './useLegacyNotificationsPaper';
import { useSxStyles } from './useStyles';

export const LegacyNotificationsPaper: React.FC = ({ children }) => {
  const sxStyles = useSxStyles();
  const { unreadNotificationsLength } = useLegacyNotificationsPaper();

  return (
    <Tooltip
      placement="bottom-end"
      leaveDelay={0}
      TransitionComponent={Fade}
      PopperProps={{
        sx: sxStyles.popper,
      }}
      title={<LegacyNotificationList />}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
    >
      <Box style={{ position: 'relative' }}>
        {children}
        {!!unreadNotificationsLength && (
          <Box sx={sxStyles.notificationNum}>{unreadNotificationsLength}</Box>
        )}
      </Box>
    </Tooltip>
  );
};
